import { databases } from "@/lib/appwrite";
import { ID, Query } from "appwrite";

const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
const collectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID!;

// para evitar varias ejecuciones 

const profileCreationInProgress: Record<string, boolean> = {};

export const createEmptyWorkerProfile = async (userId: string) => {
  if (profileCreationInProgress[userId]) {
    return;
  }

  profileCreationInProgress[userId] = true;

  try {
    const existing = await databases.listDocuments(databaseId, collectionId, [
      Query.equal("userId", userId),
    ]);

    if (existing.total > 0) {
      return existing.documents[0];
    }

    return await databases.createDocument(databaseId, collectionId, ID.unique(), {
      userId,
      // Nombre
      firstName: "",
      middleName: "",
      lastName: "",
      secondLastName: "",
      // Acceso
      email: "",
      // Personales
      birthday: "",
      bloodType: "",
      colabDniCode: "",
      phone1: "",
      phone2: "",
      emergencyContact: "",
      address: "",
      // Corporativos
      joinDate: new Date().toISOString().split("T")[0],
      rolCorp: "",
      occupation: "",
      occupationAbbreviation: "",
      colabCorpCode: "",
      area: "",
      idSupervisor: "",
      departmentId: "",
      // Bancarios
      bank: "",
      bankAccountNumber: "",
      bankAccountType: "",
      // Otros
      keyFunctions: "",
      archievements: "",
    });
  } catch (error: any) {
    if (error?.message?.includes("duplicate") || error?.code === 409) {
      const existing = await databases.listDocuments(databaseId, collectionId, [
        Query.equal("userId", userId),
      ]);
      return existing.documents[0] ?? null;
    }

    console.error("Error creando perfil:", error);
    throw error;
  } finally {
    profileCreationInProgress[userId] = false;
  }
};